import React, { useState } from "react";
import moment from "moment";
import Button from "../MainButton/MainButton";
import styles from "./TaskHeader.module.css";
import PlusIcon from "../../assets/svgs/plus.svg";
import TaskCreationModal from "../../modals/TaskCreationModal/TaskCreationModal";

const TaskHeader = ({ selectedDate, onSuccess, userName, empleado, isMobile, proyectosTodos }) => {
  const today = moment().startOf("day");
  const selDate = moment(selectedDate).startOf("day");
  const isPastDate = selDate.isBefore(today, "day");
  const [modalIsOpen, setModalIsOpen] = useState(false);

  let relativeText;
  if (selDate.isSame(today)) {
    relativeText = "de hoy ";
  } else if (selDate.isSame(moment(today).add(1, "day"))) {
    relativeText = "de mañana ";
  } else if (selDate.isSame(moment(today).subtract(1, "day"))) {
    relativeText = "de ayer ";
  } else {
    relativeText = "del ";
  }

  const formattedDate = selDate.format("D [de] MMMM");

  return (
    <div className={isMobile ? styles.taskHeaderMobile : styles.taskHeader}>
      <div className={styles.leftContainer}>
        <p className={styles.headerTitle}>Hola {userName},</p>
        <p className={`${styles.subtitle} ${isMobile ? styles.subtitleMobile : ""}`}>
          <span className={styles.singleLine}>
            Estas son tus tareas {relativeText}
            <span className={styles.dateContainer}>
              <span className={styles.dateText}>{formattedDate}</span>
            </span>
          </span>
        </p>
      </div>

      {!isMobile && (
        <Button
          variant="dark"
          onClick={() => setModalIsOpen(true)}
          rightIcon={PlusIcon}
          rightIconAlt="Añadir tarea"
          disabled={isPastDate}
          data-testid="taskButton"
        >
          Añadir tarea
        </Button>
      )}

      <TaskCreationModal
        isOpen={modalIsOpen}
        onClose={() => setModalIsOpen(false)}
        onSuccess={onSuccess}
        defaultDate={selectedDate}
        empleado={empleado}
        proyectosTodos={proyectosTodos}
      />
    </div>
  );
};

export default TaskHeader;
